import React, { useState,useEffect } from 'react';
import { useOutletContext  } from "react-router-dom";
import { Table, Input, Space, Card, Button, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import DashboardAPI from "../../restAPI/DashboardAPI";
import { useSelector } from "react-redux";

const { Column } = Table;

const documentTypeColors = {
  'Purchase Order': 'blue',
  'Sales Invoice': 'green',
  'Credit Note': 'orange',
  'Invoice': 'yellow',
};

const PendingErrorsTable = () => {
  const [searchText, setSearchText] = useState('');
  const { token } = useSelector(state => state.auth);
  const [tableData, setTableData] = useState([]);
  const {groupId, companyId} = useOutletContext();

  useEffect(() => {
    console.log("table data useEffect")
    getTableData();
  }, [groupId, companyId]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };


  const getTableData =  () =>{
      DashboardAPI.getIncompleteTradingPartnersData(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
    .then((res) => {
      if (res?.data) {
        console.log("res.data table",JSON.stringify(res.data))
        setTableData(res.data)
      }
    })
    .catch((err) => {
      console.log("error getting user data :", err.message);
    });
  }

  return (
    <Card title="Pending Documents - Incomplete Trading Partner Details" style={{ width: '100%' }}>
      <Table dataSource={tableData} pagination={{ pageSize: 4, showSizeChanger: false }}>
        <Column
          title="Invoice Number"
          dataIndex="invoiceNumber"
          key="invoiceNumber"
          sorter={(a, b) => {
            const aValue = a.invoiceNumber || "";
            const bValue = b.invoiceNumber || "";
            return aValue.localeCompare(bValue);
          }}
        />
        <Column
          title="Document Type"
          dataIndex="invoiceType"
          key="invoiceType"
          sorter={(a, b) => {
            const aValue = a.invoiceType || "";
            const bValue = b.invoiceType || "";
            return aValue.localeCompare(bValue);
          }}
          render={(invoiceType) => (
            <Tag style={{ width: '140px', textAlign: 'center' }} color={documentTypeColors[invoiceType]}>
              {invoiceType}
            </Tag>
          )}
        />
        <Column
          title="Uploaded Date"
          dataIndex="uploadedDate"
          key="uploadedDate"
          sorter={(a, b) => {
            const aDate = a.uploadedDate ? new Date(a.uploadedDate) : new Date(0);
            const bDate = b.uploadedDate ? new Date(b.uploadedDate) : new Date(0);
            return aDate - bDate;
          }}
          render={(date) => date ? new Date(date).toISOString().split("T")[0] : "N/A"}
        />
      </Table>
    </Card>
  );
};

export default PendingErrorsTable;